/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type RevokeUserSessionClientSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type RevokeUserSessionClientSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type RevokeUserSessionClientSecurity = {
  option1?: RevokeUserSessionClientSecurityOption1 | undefined;
  option2?: RevokeUserSessionClientSecurityOption2 | undefined;
};

export type RevokeUserSessionClientRequest = {
  /**
   * The user_session_client id.
   */
  id: string;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type RevokeUserSessionClientSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const RevokeUserSessionClientSecurityOption1$outboundSchema:
  z.ZodMiniType<
    RevokeUserSessionClientSecurityOption1$Outbound,
    RevokeUserSessionClientSecurityOption1
  > = z.pipe(
    z.object({
      projectSlugHeaderGramProject: z.string(),
      sessionHeaderGramSession: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function revokeUserSessionClientSecurityOption1ToJSON(
  revokeUserSessionClientSecurityOption1:
    RevokeUserSessionClientSecurityOption1,
): string {
  return JSON.stringify(
    RevokeUserSessionClientSecurityOption1$outboundSchema.parse(
      revokeUserSessionClientSecurityOption1,
    ),
  );
}

/** @internal */
export type RevokeUserSessionClientSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const RevokeUserSessionClientSecurityOption2$outboundSchema:
  z.ZodMiniType<
    RevokeUserSessionClientSecurityOption2$Outbound,
    RevokeUserSessionClientSecurityOption2
  > = z.pipe(
    z.object({
      apikeyHeaderGramKey: z.string(),
      projectSlugHeaderGramProject: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      });
    }),
  );

export function revokeUserSessionClientSecurityOption2ToJSON(
  revokeUserSessionClientSecurityOption2:
    RevokeUserSessionClientSecurityOption2,
): string {
  return JSON.stringify(
    RevokeUserSessionClientSecurityOption2$outboundSchema.parse(
      revokeUserSessionClientSecurityOption2,
    ),
  );
}

/** @internal */
export type RevokeUserSessionClientSecurity$Outbound = {
  Option1?: RevokeUserSessionClientSecurityOption1$Outbound | undefined;
  Option2?: RevokeUserSessionClientSecurityOption2$Outbound | undefined;
};

/** @internal */
export const RevokeUserSessionClientSecurity$outboundSchema: z.ZodMiniType<
  RevokeUserSessionClientSecurity$Outbound,
  RevokeUserSessionClientSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => RevokeUserSessionClientSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => RevokeUserSessionClientSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function revokeUserSessionClientSecurityToJSON(
  revokeUserSessionClientSecurity: RevokeUserSessionClientSecurity,
): string {
  return JSON.stringify(
    RevokeUserSessionClientSecurity$outboundSchema.parse(
      revokeUserSessionClientSecurity,
    ),
  );
}

/** @internal */
export type RevokeUserSessionClientRequest$Outbound = {
  id: string;
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const RevokeUserSessionClientRequest$outboundSchema: z.ZodMiniType<
  RevokeUserSessionClientRequest$Outbound,
  RevokeUserSessionClientRequest
> = z.pipe(
  z.object({
    id: z.string(),
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
    });
  }),
);

export function revokeUserSessionClientRequestToJSON(
  revokeUserSessionClientRequest: RevokeUserSessionClientRequest,
): string {
  return JSON.stringify(
    RevokeUserSessionClientRequest$outboundSchema.parse(
      revokeUserSessionClientRequest,
    ),
  );
}
